import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { EstadosDeCuentaCliente } from "../entities/estado_de_cuenta_entity";

declare var jQuery: any;

@Injectable()
export class EstadoDeCuentaService {
    private userEmpresa: ClienteXCiudad;
    private url = "datosGeneralesEmpresa";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaEstadoDeCuenta(): Observable<EstadosDeCuentaCliente> {
        try {
            this.userEmpresa = jQuery.parseJSON(this.sessionStorageService.retrieve("usuarioEmpresa"));
        } catch (e) {
            this.userEmpresa = this.sessionStorageService.retrieve("usuarioEmpresa");
        }
        let body = JSON.stringify(this.userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaEstadoDeCuenta", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/estadoDeCuenta/estado-de-cuenta.service.ts